import AnonymousDonor from './models'

export default AnonymousDonor
